module.exports = __webpack_public_path__ + "static/the-essence-of-chaos-e331043945352fb857133b4780f78414.jpg";